import { useEffect, useState, useRef } from 'react';

const useHubspotElement = () => {
  const [offsetFromTop, setOffsetFromTop] = useState(0);
  const navRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const updateOffset = () => {
      if (navRef.current) {
        const top = navRef.current.getBoundingClientRect().top;
        setOffsetFromTop(Math.round(top));
      }
    };
    updateOffset();

    const navObserver = new MutationObserver(updateOffset);
    navObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.addEventListener('resize', updateOffset);

    let visibilityObserver: MutationObserver | null = null;

    const hsAnchorObserver = new MutationObserver(() => {
      const hsAnchor = document.getElementById('hs-web-interactives-top-anchor');
      if (hsAnchor) {
        const firstOverlayCta = hsAnchor.querySelector('div[id^="hs-overlay-cta-"]');
        if (firstOverlayCta) {
          visibilityObserver = new MutationObserver(() => {
            const visibility = window.getComputedStyle(firstOverlayCta).visibility;
            if (visibility === 'hidden') {
              updateOffset();
            }
          });
          visibilityObserver.observe(firstOverlayCta, { attributes: true, childList: true });
        }
      }
    });

    hsAnchorObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      navObserver.disconnect();
      window.removeEventListener('resize', updateOffset);
      hsAnchorObserver.disconnect();
      visibilityObserver?.disconnect();
    };
  }, []);

  useEffect(() => {
    const contentContainer = document.getElementById('contentContainer');
    if (contentContainer) {
      contentContainer.style.minHeight = `calc(100vh - ${offsetFromTop}px)`;
    }
  }, [offsetFromTop]);

  return { navRef };
};

export default useHubspotElement;
